(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sticky-facets-toggle')) {
    class StickyFacetsToggle extends HTMLElement {
      constructor() {
        super();

        this.button = null;
        this.anchor = null;
        this.placeholder = null;
        this.isFixed = false;

        this.handleIntersect = this.handleIntersect.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollTimeout = null;
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.button = this.querySelector('.facets-toggle');
        if (!this.button) return;

        this.anchor = document.createElement('div');
        this.anchor.setAttribute('aria-hidden', 'true');
        this.anchor.style.height = '1px';
        this.anchor.style.pointerEvents = 'none';

        this.button.before(this.anchor);

        this.placeholder = document.createElement('div');
        this.placeholder.style.display = 'none';
        this.button.after(this.placeholder);

        this.observer = new IntersectionObserver(this.handleIntersect, {
          root: null,
          threshold: [0, 1],
          rootMargin: '100px 0px 0px 0px',
        });

        this.observer.observe(this.anchor);

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
      }

      handleIntersect(entries) {
        const entry = entries[0];

        if (entry.isIntersecting) {
          this.unfix();
        } else {
          this.fix();
        }
      }

      handleScroll() {
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
          const anchorRect = this.anchor.getBoundingClientRect();
          const hasFixedClass = this.button.classList.contains('facets-toggle--fixed');
          if (anchorRect.bottom < 0 && !hasFixedClass) {
            this.fix();
          } else if (anchorRect.top >= 0 && hasFixedClass) {
            this.unfix();
          }
        }, 10);
      }

      fix() {
        if (this.isFixed) return;

        const height = this.button.offsetHeight;
        this.placeholder.style.height = `${height}px`;
        this.placeholder.style.display = 'block';

        this.button.classList.add('facets-toggle--fixed');
        this.isFixed = true;
      }

      unfix() {
        if (!this.isFixed) return;

        this.button.classList.remove('facets-toggle--fixed');
        this.placeholder.style.display = 'none';
        this.isFixed = false;
      }

      handleResize() {
        if (this.isFixed) {
          this.placeholder.style.height = `${this.button.offsetHeight}px`;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.scrollTimeout) {
          clearTimeout(this.scrollTimeout);
        }
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
      }
    }

    customElements.define('sticky-facets-toggle', StickyFacetsToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
